import { FC } from 'react';
import { ISpecialProduct } from '@components/projects/level01/level01.state';
import styles from './special-product.module.scss';
import animations from "../../animations/animations.module.scss";
import Image from 'next/image';
import Level01Animation from '@components/projects/level01/animations';

interface SpecialProductSectionProps {
    section: ISpecialProduct;
}

const SpecialProductSection: FC<SpecialProductSectionProps> = ({section}) => {
    return (
        <Level01Animation render={(ref) => (
          <div className={styles.container}>
              <section ref={ref} className={`${styles.section} ${animations.scroll__animation}`}>
                  <div className={styles.section__content}>
                      <h2 className={styles.section__content_title}>{section.title}</h2>
                      <ul className={styles.section__content_list}>
                          {section.content.map((item, idx) => (
                            <li key={idx} className={styles.section__content_item}>{item}</li>
                          ))}
                      </ul>
                  </div>
                  <div className={styles.section__image}>
                      <div className={styles.section__image_container}>
                          <Image
                            src={section.imageUrl}
                            alt={section.title}
                            layout={'fill'}
                            objectFit={'contain'}/>
                      </div>
                  </div>
              </section>
          </div>
        )}/>
    )
}

export default SpecialProductSection;
